var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rightCenterChart flex-row-sb"},[_c('Radar',{attrs:{"id":"c2","path":"kcl_pie","height":"300px","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }